import { HotspotStyle } from '../public/types/HotspotStyle';
export class PolygonalHotspotDrawer {
    constructor(_polygonalHotspotIdentifier, _panorama) {
        this._polygonalHotspotIdentifier = _polygonalHotspotIdentifier;
        this._panorama = _panorama;
        this._mouseMoveRefresh = undefined; //it's not used in node.js app, always in browsers, therefore can be number
        this._pid = 0;
        this.addPolygonalPoint = (point) => {
            if (this._pid === 0) {
                this._panorama._pano.changeCursorToCrosshair();
                this._addPolygonalHotspot(); //can be replace late to krpano + some kind of hotspot register (provided in constructor)
            }
            this._panorama._pano.setPointXPosition(this._polygonalHotspotIdentifier, this._pid, point.xAxis);
            this._panorama._pano.setPointYPosition(this._polygonalHotspotIdentifier, this._pid, point.yAxis);
            this._pid++;
            this._moveMouse(this._pid);
        };
        this.start = () => {
            this._panorama._pano.changeCursorToCrosshair();
        };
        this.finish = () => {
            this._panorama._pano.changeCursorToDefault();
            this._panorama.removeHotspot(this._polygonalHotspotIdentifier); //can be move to krpano with sub-functions
            if (this._mouseMoveRefresh) {
                window.clearTimeout(this._mouseMoveRefresh);
            }
            this._pid = 0;
        };
        this.undo = () => {
            this._pid--;
            this._panorama._pano.undoArrowPoint(this._polygonalHotspotIdentifier, this._pid);
            this._moveMouse(this._pid);
        };
        this._addPolygonalHotspot = () => {
            const hotspot = this._panorama.addHotspot(this._polygonalHotspotIdentifier);
            hotspot.loadstyle(HotspotStyle.HotspotPolygonalManager);
            hotspot.enabled = false;
        };
        this._moveMouse = (id) => {
            if (id !== this._pid) {
                return;
            }
            const position = this._panorama._pano.calculateMousePosition();
            this._panorama._pano.setPointXPosition(this._polygonalHotspotIdentifier, this._pid, position.x);
            this._panorama._pano.setPointYPosition(this._polygonalHotspotIdentifier, this._pid, position.y);
            this._panorama._pano.updateScreen();
            //using window.setTimeout to reduce dependency on NodeJs.Timeout since we are running it only in browsers
            this._mouseMoveRefresh = window.setTimeout(() => {
                this._moveMouse(id);
            }, 0);
        };
    }
}
